import styled from "styled-components";

export const Container = styled.section`
	background: #ffffff;
	border: 1px solid #dcdfe6;
	border-radius: 10px;
	padding: 22px;
	width: 100%;
`;

export const Title = styled.h2`
	font-family: "NotoSans-Bold", sans-serif;
	font-size: 16px;
	font-weight: 700;
	color: #000e4b;
	margin: 0 0 18px 0;
`;

export const Grid = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 10px;
`;

export const ActionButton = styled.button<{
	enabledType?: "green" | "default";
}>`
	height: 67px;
	border: 0;
	border-radius: 10px;
	font-size: 13px;
	font-weight: 700;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 8px;
	position: relative;
	cursor: pointer;
	font-family: "NotoSans-SemiBold", sans-serif;
	transition: background-color 0.2s ease, color 0.2s ease;
	width: 100%;

	@media (max-width: 1200px) {
		font-size: 10px;
	}

	${({ enabledType }) => {
		if (enabledType === "green") {
			return `
				background: #ebfbf5;
				color: #00a377;
				&:hover {
					background: #d6f3ea;
				}
			`;
		}
		if (enabledType === "default") {
			return `
				background: #fafafa;
				color: #000e4b;
				&:hover {
					background: #f1f4f8;
				}
			`;
		}
		// Disabled
		return `
			background: #fafafa;
			color: #c8cbd2;
			cursor: default;
			pointer-events: none;
			svg {
				color: #c8cbd2;
			}
		`;
	}}
`;

export const SoonBadge = styled.span`
	position: absolute;
	right: 8px;
	top: 8px;
	background: #e0f2fe;
	color: #0369a1;
	border-radius: 100px;
	padding: 4px 8px;
	font-size: 8px;
	font-weight: 800;
	font-family: "NotoSans-Bold", sans-serif;
	line-height: 1;

	@media (min-width: 900px) {
		right: 3px;
		top: 13px;
		padding: 3px 6px;
		font-size: 8px;
	}
	@media (min-width: 1000px) {
		right: 3px;
		top: 13px;
		padding: 3px 6px;
		font-size: 8px;
	}

	@media (min-width: 1200px) {
		right: 3px;
		top: 13px;
		padding: 3px 6px;
		font-size: 8px;
	}
`;
